export enum PageTab {
  Templates = 'templates',
  Archived = 'archived'
}
